module.exports = __webpack_public_path__ + "public/img/ditu.98df52db.png";